import apiClient from './client';

export interface User {
  id: string;
  email: string;
  firstName?: string;
  lastName?: string;
  role: string;
  branches: string[];
  activeBranch: string;
  isActive: boolean;
  createdAt: string;
  updatedAt: string;
}

export interface CreateUserRequest {
  email: string;
  password: string;
  firstName: string;
  lastName: string;
  role: string;
}

export interface UpdateUserRequest {
  email?: string;
  firstName?: string;
  lastName?: string;
  role?: string;
  branches?: string[];
  isActive?: boolean;
}

export interface SwitchBranchRequest {
  branchId: string;
}

export const usersApi = {
  getAll: async (): Promise<User[]> => {
    const response = await apiClient.get('/users');
    return response.data.map((item: any) => ({ ...item, id: item._id }));
  },

  getById: async (id: string): Promise<User> => {
    const response = await apiClient.get(`/users/${id}`);
    return { ...response.data, id: response.data._id };
  },

  create: async (data: CreateUserRequest): Promise<User> => {
    const response = await apiClient.post('/users', data);
    return { ...response.data, id: response.data._id };
  },

  update: async (id: string, data: UpdateUserRequest): Promise<User> => {
    const response = await apiClient.put(`/users/${id}`, data);
    return { ...response.data, id: response.data._id };
  },

  delete: async (id: string): Promise<void> => {
    await apiClient.delete(`/users/${id}`);
  },

  switchBranch: async (id: string, data: SwitchBranchRequest): Promise<User> => {
    const response = await apiClient.put(`/users/${id}/switch-branch`, data);
    return { ...response.data, id: response.data._id };
  },
};
